import { RefObject, useEffect, useState } from 'react';
import { isContainerMeasurable } from './multiMapUtils';

function scheduleContainerCheck(
  containerRef: RefObject<HTMLDivElement | null>,
  setContainerReady: (ready: boolean) => void,
): void {
  const checkContainer = () => {
    if (!containerRef.current || !containerRef.current.isConnected) {
      setContainerReady(false);
      return;
    }

    if (isContainerMeasurable(containerRef.current)) {
      Promise.resolve().then(() => {
        setContainerReady(isContainerMeasurable(containerRef.current));
      });
      return;
    }

    setTimeout(() => {
      setContainerReady(isContainerMeasurable(containerRef.current));
    }, 100);
  };

  setTimeout(() => {
    requestAnimationFrame(checkContainer);
  }, 100);
}

export function useMultiMapContainerReady(
  containerRef: RefObject<HTMLDivElement | null>,
  fullscreen: boolean,
  addressesLength: number,
): boolean {
  const [containerReady, setContainerReady] = useState(false);

  useEffect(() => {
    const checkContainer = () => {
      if (containerRef.current && containerRef.current.isConnected) {
        if (isContainerMeasurable(containerRef.current)) {
          setContainerReady(true);
        } else {
          requestAnimationFrame(() => {
            if (isContainerMeasurable(containerRef.current)) {
              setContainerReady(true);
            }
          });
        }
      } else {
        setContainerReady(false);
      }
    };

    if (containerRef.current) {
      requestAnimationFrame(checkContainer);
    } else {
      setContainerReady(false);
    }
  }, [containerRef, fullscreen]);

  useEffect(() => {
    setContainerReady(false);

    const timeoutId = setTimeout(() => {
      scheduleContainerCheck(containerRef, setContainerReady);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      setContainerReady(false);
    };
  }, [addressesLength, containerRef]);

  return containerReady;
}
